export default __webpack_public_path__ + "static/media/promo.db13f101.svg";